// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-PWhn","footer-content":"footer-content-3chE","footerContent":"footer-content-3chE","container":"container-B1Ko"};